import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'sweetalert2/dist/sweetalert2.css'
import 'flatpickr/dist/flatpickr.min.css'
import { Provider } from 'mobx-react'

import App from './App'
import { stores } from './stores'
// froala editor
window.$ = require('jquery')

ReactDOM.render(
  <Provider {...stores}>
    <App />
  </Provider>,
  document.getElementById('root')
)
